import axios from "axios";

const BASE_URL = "https://gg-api.nationtonation.ca/api/orders";
const PAYMENTS_URL = "https://gg-api.nationtonation.ca/api/payments";


// Define the Order type
interface Order {
  fulfillment_status: string;
  order_status: string;
  id: number;
  customer_id: number;
  status: string;
  total: number;
  created_at: string;
  master_customer_id?: number | null;
  master_customer_name?: string | null;
}
// In ordersApi.ts - update fetchOrders
export const fetchOrders = async (): Promise<Order[]> => {
  try {
    const response = await axios.get(`${BASE_URL}`, { // Removed ?includeMasterData=true
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    console.log("Orders API Response:", response.data);
    
    // Ensure we're getting the fulfillment_status from backend
    return response.data.map((order: any) => ({
  ...order,
  fulfillment_status: order.fulfillment_status || 'unfulfilled',
  order_status: order.order_status || 'pending_approval',
  status: order.status || 'pending',
  master_customer_name: order.master_customer_name || null,
}));

  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};





// Fetch order details by order ID
export const fetchOrderDetails = async (orderId: number) => {
  try {
    const response = await axios.get(`${BASE_URL}/${orderId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching order details:", error);
    throw error;
  }
};

// Fetch outstanding balance by order ID
export const fetchOutstandingBalance = async (orderId: string | number) => {
  try {
    const response = await axios.get(`${BASE_URL}/${orderId}/outstanding-balance`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching outstanding balance:", error);
    throw error;
  }
};

// Update order status
export const updateOrderStatus = async (orderId: number, status: string) => {
  try {
    await axios.put(
      `${BASE_URL}/${orderId}/status`,
      { status },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }
    );
  } catch (error) {
    console.error("Error updating order status:", error);
    throw error;
  }
};

// Fetch payments by order ID
export const fetchPaymentsByOrderId = async (orderId: number) => {
  try {
    const response = await axios.get(`${PAYMENTS_URL}/${orderId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching payments:", error);
    throw error;
  }
};

// Fetch payment history by order ID
export const fetchPayments = async (orderId: number) => {
  try {
    const response = await axios.get(`${PAYMENTS_URL}/${orderId}/history`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching payment history:", error);
    throw error;
  }
};

// Create a new order
export const createOrder = async (order: any) => {
  try {
    const response = await axios.post(BASE_URL, order, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating order:", error);
    throw error;
  }
};
